import { render } from "./HeroImg.vue?vue&type=template&id=027b5400"
import script from "./HeroImg.vue?vue&type=script&lang=js"
export * from "./HeroImg.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__